import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { Select, Store } from "@ngxs/store";
import { Observable, Subject } from "rxjs";
import { AdvancedReportPreviewState, AdvancedReportPreviewStateModel, InitAdvancedReportPreview, LoadAdvancedReportPreview } from "./advanced-report-preview.state";

@Component({
    selector: 'pv-advanced-report-preview-view',
    templateUrl: 'advanced-report-preview.view..html',
    styleUrls: ['advanced-report-preview.view.scss'],
    host: {
        class: 'pv-advanced-report-preview-view',
    }
})
export class AdvancedReportPreview implements OnInit, OnDestroy {

    @Select(AdvancedReportPreviewState)
    state$: Observable<AdvancedReportPreviewStateModel>;

    private _destroy$ = new Subject();

    constructor(
        private _route: ActivatedRoute,
        private _store: Store,
    ) {}

    ngOnInit() {
        this._route.paramMap.subscribe(params => {
            this._store.dispatch(new InitAdvancedReportPreview(params.get('shareKey')));
        });
    }

    ngOnDestroy() {
        this._destroy$.next();
        this._destroy$.complete();
    }

    refresh() {
        this._store.dispatch(new LoadAdvancedReportPreview());
    }
}